import { render, staticRenderFns } from "./ShippingRanges.vue?vue&type=template&id=66835ef0&scoped=true&"
import script from "./ShippingRanges.vue?vue&type=script&lang=js&"
export * from "./ShippingRanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66835ef0",
  null
  
)

export default component.exports